import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface InstaPostSkeletonProps {
  trendsOpen?: boolean;
}

const InstaPostSkeleton: React.FC<InstaPostSkeletonProps> = ({
  trendsOpen = false,
}) => {
  const imageHeight = trendsOpen ? 190 : 300;
  const cardWidth = trendsOpen ? "w-[158px]" : "w-[240px]";
  const cardHeight = trendsOpen ? "h-[260px]" : "h-[380px]";
  const imageContainerHeight = trendsOpen ? "h-[190px]" : "h-[300px]";
  const sourceBadgePadding = trendsOpen ? "px-2 py-1" : "px-1 py-0.5";
  const textLineHeight = trendsOpen ? 10 : 12;

  return (
    <div
      className={`${cardWidth} ${cardHeight} p-0 pb-3 gap-2 border border-light rounded-2xl relative overflow-hidden`}
    >
      <div
        className={`relative w-full ${imageContainerHeight} overflow-hidden rounded-t-2xl`}
      >
        <Skeleton
          height={imageHeight}
          width="100%"
          borderRadius={0}
          className="block leading-none"
        />
        <div
          className={`absolute top-0 right-0 rounded-bl-lg rounded-tr-2xl ${sourceBadgePadding}`}
        >
          <Skeleton
            width={trendsOpen ? 40 : 60}
            height={textLineHeight}
            borderRadius={4}
          />
        </div>
        <div className="absolute bottom-2 right-2 flex space-x-1">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="bg-white flex w-5 h-5 items-center justify-center rounded-full"
            >
              <Skeleton circle height={12} width={12} />
            </div>
          ))}
        </div>
      </div>
      <div
        className={`p-2 space-y-0.5 relative ${trendsOpen ? "leading-3" : ""}`}
      >
        <Skeleton width={trendsOpen ? 80 : 100} height={textLineHeight} />
        <Skeleton width={trendsOpen ? 90 : 120} height={textLineHeight} />
        <Skeleton width={trendsOpen ? 70 : 100} height={textLineHeight} />
        <div className="absolute bottom-1.5 right-2">
          <Skeleton width={12} height={12} />
        </div>
      </div>
    </div>
  );
};

interface TrendsRowSkeletonProps {
  trendsOpen?: boolean;
  cardCount?: number;
}

export const TrendsRowSkeleton: React.FC<TrendsRowSkeletonProps> = ({
  trendsOpen = false,
  cardCount = 4,
}) => (
  <div className="space-y-4 mb-4">
    <div className="w-full flex justify-between items-center">
      <div className="flex space-x-2 items-center">
        <Skeleton width={120} height={16} />
        <div className="w-[2px] h-[18px] bg-[#4b4b4b]" />
        <Skeleton width={60} height={24} borderRadius={999} />
        <Skeleton width={60} height={24} borderRadius={999} />
      </div>
      <div className="flex space-x-4 items-center">
        <Skeleton width={200} height={14} />
        <Skeleton circle width={16} height={16} />
        <Skeleton circle width={16} height={16} />
        <Skeleton circle width={16} height={16} />
      </div>
    </div>
    <div className="flex flex-wrap justify-evenly gap-4">
      {Array.from({ length: cardCount }).map((_, index) => (
        <InstaPostSkeleton key={index} trendsOpen={trendsOpen} />
      ))}
    </div>
  </div>
);

interface DesignerPagePostsGridSkeletonProps {
  trendsOpen?: boolean;
  count?: number;
}

export const DesignerPagePostsGridSkeleton: React.FC<
  DesignerPagePostsGridSkeletonProps
> = ({ trendsOpen = false, count = 12 }) => (
  <div className="flex flex-wrap justify-evenly gap-4">
    {Array.from({ length: count }).map((_, index) => (
      <InstaPostSkeleton key={index} trendsOpen={trendsOpen} />
    ))}
  </div>
);

export default InstaPostSkeleton;
